export const getters = {
    getProduto: state => state.produto,
    getProdutos: state => state.produtos,
    getModalCadastroProduto: state => state.modalCadastroProduto,
    getModalExcluirProduto: state => state.modalExcluirProduto,
    getModalClonarProduto: state => state.modalClonarProduto,
    getTiposProduto: state => state.tiposProduto,
    getFotoProduto: state => state.foto,
    getModalTransferenciaEstoqueProduto: state => state.modalTransferenciaEstoqueProduto,
}

export default {}